import React from "react";
import flexBox from "../../assets/styles/common/flexBox.module.css";
import {
  Grid2,
  Box,
  Stack, Divider,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
  Chip,
  Avatar,
} from "@mui/material";
import PropTypes from 'prop-types';

import { Place, Business, Spa, KeyboardArrowRight } from "@mui/icons-material";
import main_fourth_beanVariety_icon from "../../assets/images/homeImages/main_fourth_beanVariety_icon.svg";
import main_fourth_processingMethod_icon from "../../assets/images/homeImages/main_fourth_processingMethod_icon.svg";


const SearchInfoCard = ({
  dataImageUrl,
  dataTitle,
  dataFarmName,
  dataProductionYear,
  dataBeanVariety,
  dataProcessingMethod,
  dataProductionCountry,
  dataTitleOnClick,
  dataImageOnClick,
  dataCompanyName,
  handleDetailClick,
  index,
}) => {
  return (
    <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
      <Card
        sx={{
          maxWidth: "100%",
          minWidth: "auto",
          position: "relative",
          border: '1px solid #E1E1E1',
          borderRadius: "5px",
          p: 2,
          minHeight: { xs: "auto", sm: "502px", md: "422.16px" , lg: "422.16px"  },
        }}
      >
        <Box
          sx={{
            position: "relative",
            "&::after": {
              content: '""',
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(0,0,0,0.25)",
              zIndex: 1,
            },
          }}
        >
          <CardMedia
            component="img"
            sx={{
              maxWidth: "100%",
              width: "100%",
              height: "auto",
              cursor: "pointer",
              zIndex: -1,
              opacity: 0.8,
              backgroundColor: "#403C40",
            }}
            image={dataImageUrl}
            alt={dataTitle || "Default Image"}
            onClick={dataImageOnClick}
          />
          <Typography
            onClick={dataTitleOnClick}
            gutterBottom
            variant="h6"
            component="div"
            sx={{
              zIndex: 2,
              position: "absolute",
              left: 0,
              top: 0,
              height: "100%",
              maxWidth: "100%",
              color: "#fff",
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitBoxOrient: "vertical",
              wordWrap: "break-word",
              WebkitLineClamp: 3,
              p: 1.5,
              display: "flex",
              alignItems: "center",
              fontWeight: "500",
            }}
          >
            {dataTitle}
          </Typography>
          {/* 생두 이름 */}
        </Box>
        {index !== undefined && index !== null ?
        <Box sx={{ position: "absolute", top: 14, left: 22 }}>
          <Typography variant="h5" color="white" >{index + 1}</Typography>
        </Box>
        :null}
        <CardContent sx={{ p: 0, pt: 0, pb: 1.25, '@media (min-width: 1200px)': { minHeight: '180px', }, '@media (min-width: 800px)': { minHeight: '120px', }, '@media (min-width: 600px)': { minHeight: '80px', }, }}>
          <Box sx={{ gap: 1, width: "100%", mt: 1 }}>
            <Box className={flexBox.flexRowCenterSide}>
              <Stack direction="row" gap={0.5}>
                <Typography>Year</Typography>
                <Typography
                  sx={{
                    fontSize: "1.0rem",
                    fontWeight: "bold",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    color: "#131213",
                  }}
                  gutterBottom
                  component="div"
                >
                  {dataProductionYear}
                </Typography>
              </Stack>
              <Button
                onClick={handleDetailClick}
                sx={{
                  p: 0.5,
                  mt: 0,
                  minWidth: "0",
                  ml: 1,
                  color: "#131213",
                }}
                endIcon={<KeyboardArrowRight />}
              >
                Detail
              </Button>
            </Box>
            <Divider sx={{ mt: 0, mb: 0.5, p: 0, borderStyle: "dotted" }} />

            <Stack direction="row" gap={0}>
              <Typography
                onClick={dataTitleOnClick}
                gutterBottom
                variant="h6"
                component="div"
                sx={{
                  display: "-webkit-box",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  WebkitBoxOrient: "vertical",
                  wordWrap: "break-word",
                  WebkitLineClamp: 1,
                }}
              >
                {dataProductionCountry}
              </Typography>
              <span style={{ paddingTop: "5px" }}>
                <Place sx={{ color: "#B0B0B0", fontSize: "14px", mt: 0.25 }} />
              </span>
            </Stack>
            
            <Stack direction="row" gap={0.5}>
              <Business sx={{ color: "#B0B0B0", fontSize: "14px", mt: 0.25 }} />
              <Typography
                sx={{
                  fontSize: "0.8125rem",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                gutterBottom
                component="div"
              >
                {dataCompanyName}
              </Typography>
            </Stack>
            {/* 수입회사 */}
            <Stack direction="row" gap={0.5}>
              <Spa sx={{ color: "#B0B0B0", fontSize: "14px", mt: 0.25 }} />
              <Typography
                sx={{
                  fontSize: "0.8125rem",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                gutterBottom
                component="div"
              >
                {dataFarmName}
              </Typography>
            </Stack>
            {/* 생산농장 */}
            <Box direction="row" sx={{ flexWrap: "wrap" }}>
              {Array.isArray(dataBeanVariety) &&
                dataBeanVariety.map((tag, index) => (
                  <Chip
                    key={index}
                    avatar={
                      <Avatar
                        src={main_fourth_beanVariety_icon}
                        alt="Processing Method"
                      />
                    }
                    label={tag}
                    sx={{
                      fontSize: "0.75rem",
                      height: "24px",
                      "& .MuiChip-label": { pl: 1, pr: 1 },
                    }}
                  />
                ))}

              <Chip
                avatar={
                  <Avatar
                    src={main_fourth_processingMethod_icon}
                    alt="Processing Method"
                  />
                }
                label={dataProcessingMethod}
                sx={{
                  fontSize: "0.75rem",
                  height: "24px",
                  "& .MuiChip-label": { pl: 1, pr: 1 },
                }}
              />
            </Box>
            {/* 품종 및 가공방법 */}
          </Box>
        </CardContent>
      </Card>
    </Grid2>
  );
};

SearchInfoCard.propTypes = {
  dataImageUrl: PropTypes.string,
  dataTitle: PropTypes.string,
  dataFarmName: PropTypes.string,
  dataProductionYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), 
  dataBeanVariety: PropTypes.arrayOf(PropTypes.string),
  dataProcessingMethod: PropTypes.string,
  dataProductionCountry: PropTypes.string,
  dataTitleOnClick: PropTypes.func,
  dataImageOnClick: PropTypes.func,
  dataCompanyName: PropTypes.string,
  handleDetailClick: PropTypes.func.isRequired,
  index: PropTypes.number,
};

export default SearchInfoCard;
